import {Trans, useTranslation} from 'react-i18next';
import {Clock, ExternalLink, ScanFace, Scale, Trash2} from 'lucide-react';
import {Button, Link, ResponsiveSheet} from '@chekinapp/ui';
import {ModalPointRow} from '@chekin/shared';
import {usePrivacyPolicyLink} from 'hooks/usePrivacyPolicyLink';

type SheetProps = {
  open: boolean;
  onClose: () => void;
};

const POINTS = [
  {id: 'identity-only', icon: <ScanFace />, i18nKey: 'photos_point_identity_only'},
  {id: 'until-checkin', icon: <Clock />, i18nKey: 'photos_point_kept_until_checkin'},
  {id: 'deleted', icon: <Trash2 />, i18nKey: 'photos_point_deleted_after_retry'},
  {id: 'never-shared', icon: <Scale />, i18nKey: 'photos_point_never_shared'},
];

export const TreatImagesInfoSheet = ({open, onClose}: SheetProps) => {
  const {t} = useTranslation();
  const {href: privacyPolicyHref} = usePrivacyPolicyLink();

  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      title={t('how_we_treat_your_photos')}
      description={t('photos_required_to_register_intro')}
      className="treat-images-modal"
      dialogClassName="max-w-[430px] sm:max-w-[430px]"
      closeOnOverlayClick
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
    >
      <div className="mt-4 flex flex-col gap-4">
        <div className="flex flex-col gap-3">
          {POINTS.map(point => (
            <ModalPointRow key={point.id} icon={point.icon}>
              <Trans i18nKey={point.i18nKey} components={{1: <b />}} />
            </ModalPointRow>
          ))}
        </div>

        <Link
          href={privacyPolicyHref}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 self-start text-[12.5px] font-semibold text-[var(--chekin-color-brand-blue)] hover:underline [&_svg]:size-3.5"
        >
          {t('read_our_privacy_policy')}
          <ExternalLink />
        </Link>

        <Button onClick={onClose}>{t('got_it')}</Button>
      </div>
    </ResponsiveSheet>
  );
};
